export default __webpack_public_path__ + "static/media/endRound5.b3c239e1.mp3";